import React from 'react';

/**
 * Simple pill tabs for list filters. Keep labels short; optional count per tab.
 */
export function FilterTabs({ value, onChange, tabs, className = '', size = 'md', dense = false }) {
  const pad = size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm';
  return (
    <div
      className={['flex flex-wrap items-center gap-1.5', className].join(' ')}
      role="tablist"
      aria-label="Filter"
    >
      {tabs.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.id)}
            className={[
              'rounded-full border font-semibold transition-colors shrink-0',
              pad,
              dense ? 'max-w-[11rem] truncate' : '',
              active
                ? 'border-primary-600 bg-primary-600 text-white shadow-sm'
                : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50',
            ].join(' ')}
            title={t.label}
          >
            {t.label}
            {t.count != null && (
              <span className={active ? 'ml-0.5 opacity-90' : 'ml-0.5 text-slate-500'}>({t.count})</span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default FilterTabs;
